import {
  MembershipState,
  MembershipStep,
} from "components/Membership/membershipTypes";
import StepReaderProfile from "components/Step/StepReaderProfile";
import { ReaderProfileKey } from "components/Step/stepTypes";

export interface MembershipStepReaderProfileProps extends MembershipState {
  suppressBackButton?: boolean;
}

export const MembershipStepReaderProfile = ({
  checkoutSession,
  contentfulQuizModelParsed,
  onSubmit,
  routePrevStep,
  suppressBackButton = false,
}: MembershipStepReaderProfileProps) => {
  const p = checkoutSession?.personalization;

  const readerProfileValues = {
    [ReaderProfileKey.NAME]: p?.firstName || "",
    [ReaderProfileKey.MONTH]: p?.birthMonth ? String(p?.birthMonth) : "",
    [ReaderProfileKey.YEAR]: p?.birthYear ? String(p?.birthYear) : "",
  };

  const backButtonProps = {
    onClick: () => routePrevStep?.(),
  };

  return (
    <StepReaderProfile
      contentfulQuizModel={contentfulQuizModelParsed}
      onSubmit={onSubmit}
      readerProfileValues={readerProfileValues}
      stepFooterProps={{
        backButtonProps,
        suppressBackButton,
      }}
      stepHeaderProps={{
        backButtonProps,
        suppressBackButton,
      }}
    />
  );
};

export const MEMBERSHIP_STEP_READER_PROFILE: MembershipStep = {
  component: MembershipStepReaderProfile,
  id: "membership-id-reader-profile",
  slug: "reader-profile",
};

export const MEMBERSHIP_STEP_READER_PROFILE_SUPPRESS_BACK_NAVIGATION: MembershipStep =
  {
    ...MEMBERSHIP_STEP_READER_PROFILE,
    component: (state) => (
      <MembershipStepReaderProfile {...state} suppressBackButton />
    ),
  };
